import type { ReactNode } from 'react';
import Navbar from './Navbar';
import { useT } from '../i18n/LangProvider';

export default function Layout({ children }: { children: ReactNode }) {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-bg-base selection:bg-brand-red selection:text-white">
      <Navbar />
      <main>{children}</main>
      <footer className="border-t border-white/[0.06] py-12 bg-bg-base">
        <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-20 flex flex-wrap items-end justify-between gap-6">
          <div className="flex items-center gap-3">
            <img src="https://www.tecsys.com/hubfs/Tecsys%20Theme%20Assets/Logos/tecsys-logo-primary.svg" alt="Tecsys" className="h-10 w-auto" />
            <div>
              <div className="font-display text-lg tracking-tight">{t('footer.eventName')}</div>
              <p className="text-xs text-ink-muted mt-0.5 font-mono">{t('footer.subtitle')}</p>
            </div>
          </div>
          <p className="text-xs text-ink-muted font-mono">{t('footer.internal')}</p>
        </div>
      </footer>
    </div>
  );
}
